import angular from 'angular';

export const ClickMeOnEnter = ($timeout, $window) => {
  "ngInject";

  return {
    restrict: 'A',
    link ($scope, $element, $attrs) {
      angular.element($window).on('keypress', (evt) => {
        if (evt.which === 13) {
          evt.preventDefault();
          $element[0].click();
        }
        return false;
      });
      $element.on('$destroy', () => { });
    }
  };
};


// WEBPACK FOOTER //
// ./src/app/directives/click-me-on-enter.directive.js